import { Component } from '@angular/core';

@Component({
  selector: 'app-base-card',
  standalone: true,
  imports: [],
  templateUrl: './base-card.component.html',
  styleUrl: './base-card.component.scss'
})
export class BaseCardComponent {

}
